<script setup lang="ts">
import Badge from './ui/badge/Badge.vue'

const props = defineProps<{
  text?: string
}>()
</script>
<template>
  <Badge v-if="props.text" :variant="'outline'">
    {{ props.text }}
  </Badge>
</template>
